/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Admin_Stcolsessions2Inputs */

const zh_landing_admin_stcolsessions2 = /** @type {(inputs: Landing_Admin_Stcolsessions2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`学习次数`)
};

const en_landing_admin_stcolsessions2 = /** @type {(inputs: Landing_Admin_Stcolsessions2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sessions`)
};

const es_landing_admin_stcolsessions2 = /** @type {(inputs: Landing_Admin_Stcolsessions2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesiones`)
};

/**
* | output |
* | --- |
* | "Sessions" |
*
* @param {Landing_Admin_Stcolsessions2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const landing_admin_stcolsessions2 = /** @type {((inputs?: Landing_Admin_Stcolsessions2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Admin_Stcolsessions2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_admin_stcolsessions2(inputs)
	if (locale === "en") return en_landing_admin_stcolsessions2(inputs)
	return es_landing_admin_stcolsessions2(inputs)
});
export { landing_admin_stcolsessions2 as "landing_admin_stColSessions" }